<template>
  <div v-if="description" class="dialog-field-desc">
    {{ description }}
  </div>
</template>

<script>
import dialogFieldDescriptions from '../../config/dialogFieldDescriptions'

export default {
  name: 'DialogFieldDesc',
  props: {
    dialog: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    description() {
      if (this.text) return this.text
      if (!this.dialog || !this.field) return ''
      const dialogConfig = dialogFieldDescriptions[this.dialog]
      return dialogConfig && dialogConfig[this.field] ? dialogConfig[this.field] : ''
    }
  }
}
</script>
